import { AuthProvider } from '../context/auth'
import { JobsProvider } from '../context/jobs'
import { ProductsProvider } from '../context/products'

export function AppProvider({ children }) {
  return (
    <AuthProvider>
      <ProductsProvider>
        <JobsProvider>{children}</JobsProvider>
      </ProductsProvider>
    </AuthProvider>
  )
}
